<div class="modal-wrapper detail--container" [formGroup]="modelForm">
  <hospitality-bot-dialog-header
    [title]="heading"
    [icon]="icon || 'pi pi-exclamation-triangle'"
    [iconClass]="iconClass || ''"
    [subtitle]="isDate ? ((fromDate ? (fromDate | date: 'dd/MM/yyyy') : '--/--/----') + ' to ' + (toDate ? (toDate | date: 'dd/MM/yyyy') : '--/--/----')) : ''"
    (onClose)="close()"
  ></hospitality-bot-dialog-header>

  <div class="modal-body body">
    <div class="title" *ngIf="title?.length">{{ title }}</div>

    <div
      class="descriptions modal-lead"
      *ngIf="
        !htmlDescription && showDescriptionBlock && descriptions?.length != 0;
        else htmlDescTpl
      "
    >
      <p class="modal-lead__text text" *ngFor="let text of descriptions">
        {{ text }}
      </p>
    </div>

    <ng-template #htmlDescTpl>
      <div
        *ngIf="showDescriptionBlock && htmlDescription"
        class="descriptions modal-lead"
        [innerHTML]="htmlDescription | safeHtml"
      ></div>
    </ng-template>

    <hospitality-bot-info-note
      *ngIf="infoNote"
      [type]="infoNoteType"
      [icon]="infoNoteIcon"
      [customClass]="infoNoteClass"
      [customStyle]="infoNoteStyle"
    >
      <span *ngIf="infoNoteText && !infoNoteTemplate" [innerHTML]="infoNoteText"></span>
      <ng-container
        *ngIf="infoNoteTemplate"
        [ngTemplateOutlet]="infoNoteTemplate"
        [ngTemplateOutletContext]="templateContext"
      ></ng-container>
    </hospitality-bot-info-note>

    <div class="form-row" *ngIf="isLateCheckout">
      <hospitality-bot-select
        [class]="folioOptions?.length ? 'half-width' : 'full-width'"
        controlName="extendedTime"
        label="Updated Checkout Time *"
        [options]="checkoutTimeOptions"
        [props]="{ placeholder: 'Select Checkout Time' }"
      ></hospitality-bot-select>

      <hospitality-bot-action-select
        class="half-width"
        *ngIf="folioOptions?.length"
        controlName="folioNumber"
        label="Select Folio"
        [required]="true"
        [showHeader]="false"
        [options]="folioOptions"
        [isAppendToBody]="true"
        [placeholder]="'Select Folio'"
      ></hospitality-bot-action-select>
    </div>

    <div class="reservation-charge-card" *ngIf="isReservation">
      <div class="charge-status-row">
        <div class="charge-status-info">
          <span class="charge-status-label">{{ heading ? heading + ' Charges' : 'Chargeable Status' }}</span>
          <span class="charge-status-hint">
            {{ modelForm.get('chargeable')?.value ? 'Charges will be added to the guest folio' : 'Complimentary / Non-chargeable' }}
          </span>
        </div>
        <hospitality-bot-toggle-switch
          class="charge-status-toggle"
          controlName="chargeable"
          onLabel="Chargeable"
          offLabel="Non-chargeable"
        ></hospitality-bot-toggle-switch>
      </div>

      <div class="charge-details-row" *ngIf="modelForm.get('chargeable')?.value">
        <hospitality-bot-input
          class="half-width amount-input"
          label="Amount (₹) *"
          controlName="chargedAmount"
          [props]="{
            type: 'number',
            placeholder: '0.00',
            min: 0
          }"
        ></hospitality-bot-input>

        <hospitality-bot-option-checkbox-group
          class="half-width"
          controlName="inclusiveTax"
          label="Tax"
        ></hospitality-bot-option-checkbox-group>
      </div>
    </div>

    <hospitality-bot-text-area
      *ngIf="isRemarks"
      class="full-width remarks-field"
      controlName="remarks"
      label="Remarks *"
      [props]="{
        placeholder: 'Enter remarks',
        maxLength: 200
      }"
    ></hospitality-bot-text-area>

    <hospitality-bot-text-area
      *ngIf="isReason"
      class="full-width remarks-field"
      controlName="reason"
      label="Reason *"
      [props]="{
        placeholder: 'Enter reason',
        maxLength: 200
      }"
    ></hospitality-bot-text-area>

    <div class="upload-csv-container" *ngIf="isCsvUpload">
      <span class="heading">Upload CSV</span>
      <div class="upload-box">
        <div class="upload-content">
          <img
            *ngIf="!selectedFile"
            src="assets/svg/gallery-import.svg"
            alt=""
          />

          <div class="upload-title" *ngIf="!selectedFile">
            <div>Click to choose file</div>
            <div class="subtitle">
              Max: {{ formatSize(uploadCsvConfig.maxFileSize) }} file
            </div>
          </div>

          <div class="file-row" *ngIf="selectedFile">
            <div class="file-info">
              <img src="assets/svg/excel-file.svg" alt="" />
              <span class="file-name">
                {{ selectedFile.name }}
              </span>
            </div>
            <span (click)="selectedFile = null" class="remove-btn">
              <i class="pi pi-times"></i>
            </span>
          </div>

          <ng-container *ngIf="!selectedFile; else importFile">
            <hospitality-bot-upload-csv
              class="choose-btn"
              [isDisable]="false"
              (fileData)="onChooseFile($event)"
              [chooseIcon]="''"
              [fileType]="uploadCsvConfig?.fileType"
              [label]="uploadCsvConfig.chooseFileLabel"
              [maxFileSize]="uploadCsvConfig.maxFileSize"
            ></hospitality-bot-upload-csv>
          </ng-container>

          <ng-template #importFile>
            <hospitality-bot-button
              class="import-btn"
              (onClick)="onCsvImport(uploadCsvConfig)"
              [label]="uploadCsvConfig.importFileLabel"
            ></hospitality-bot-button>
          </ng-template>
        </div>
      </div>

      <div class="sample-section">
        <div class="sample-left">
          <div class="sample-title">
            <i class="pi pi-info-circle"></i>
            {{ uploadCsvConfig?.infoTitle }}
          </div>

          <div class="sample-description">
            {{ uploadCsvConfig?.infoDesc }}
          </div>
        </div>

        <button class="download-btn" (click)="downloadSampleFile()">
          <img src="assets/svg/download-file.svg" alt="" />
          Download Sample File
        </button>
      </div>
    </div>

    <ng-content></ng-content>

    <ng-container
      *ngTemplateOutlet="customTemplate; context: templateContext"
    ></ng-container>
  </div>

  <div class="modal-footer actions" *ngIf="showActionsCTA">
    <ng-container *ngIf="!!actions?.length; else defaultCTA">
      <hospitality-bot-button
        *ngFor="let action of actions"
        [label]="action.label"
        (onClick)="onButtonClick(action)"
        [variant]="action.variant"
      ></hospitality-bot-button>
    </ng-container>
  </div>
</div>

<ng-template #defaultCTA>
  <hospitality-bot-button
    [label]="defaultAction.label"
    (onClick)="defaultAction.onClick()"
    [variant]="defaultAction.variant"
  ></hospitality-bot-button>
</ng-template>

<ng-template #empty>--/--/----</ng-template>

